const LITE = {
  //getReservations
  LITE_RESERVATIONS: 'LITE_RESERVATIONS',

  //getReservationDetails
  LITE_RESERVATION_DETAILS: 'LITE_RESERVATION_DETAILS',

  //getRenterCalendarReservations
  LITE_RENTER_CALENDAR_RESERVATIONS: 'LITE_RENTERS_CALENDAR_RESERVATIONS',
  //getRenterActivePriceList
  RENTER_ACTIVE_PRICE_LIST: 'RENTER_ACTIVE_PRICE_LIST',

  LITE_RENTER_PROPERTIES: 'LITE_RENTER_PROPERTIES',
  LITE_RENTER_UNITS: 'LITE_RENTER_UNITS',
  LITE_OCCUPANCY_DETAILS: 'LITE_OCCUPANCY_DETAILS',
  LITE_RENTERS: 'LITE_RENTERS',
  LITE_PROPERTIES: 'LITE_PROPERTIES',

  //getUnit
  LITE_UNITS_UNIT: 'LITE_UNITS_UNIT',
  //getUnitPriceList
  LITE_UNITS_UNIT_PRICE_LIST: 'LITE_UNITS_UNIT_PRICE_LIST',

  //getDocuments
  LITE_DOCUMENTS: 'LITE_DOCUMENTS',

  //getReservationDocument
  LITE_RESERVATION_DOCUMENT: 'LITE_RESERVATION_DOCUMENT',

  //getDocument
  LITE_DOCUMENT: 'LITE_DOCUMENT',

  // getComments
  LITE_COMMENTS: 'LITE_COMMENTS',
  // getCommentDetails
  LITE_COMMENT_DETAILS: 'LITE_COMMENT_DETAILS',
  //getCalculationGuests
  LITE_CALCULATION_GUESTS: 'LITE_CALCULATION_GUESTS',
  //getProfileDetails
  LITE_PROFILE_DETAILS: 'LITE_PROFILE_DETAILS',
  //getLatestReservations
  LITE_LATEST_RESERVATIONS: 'LITE_LATEST_RESERVATIONS',
  //getLatestComments
  LITE_LATEST_COMMENTS: 'LITE_LATEST_COMMENTS',
  //getReservationStats
  LITE_RESERVATION_STATS: 'LITE_RESERVATION_STATS',
  //getReservations
  LITE_DASHBOARD_RESERVATIONS: 'LITE_DASHBOARD_RESERVATIONS',
  //getProperties
  LITE_RENTALS_PROPERTIES: 'LITE_RENTALS_PROPERTIES',
  //getPropertyPriceList
  LITE_RENTALS_PROPERTY_PRICE_LIST: 'LITE_RENTALS_PROPERTY_PRICE_LIST',
  //getCMPartners
  LITE_RENTALS_CM_PARTNERS: 'LITE_RENTALS_CM_PARTNERS',
  //getDocumentsInformations
  LITE_DOCUMENTS_INFORMATIONS: 'LITE_DOCUMENTS_INFORMATIONS',
  //getCalculation
  LITE_DOCUMENTS_CALCULATION: 'LITE_DOCUMENTS_CALCULATION',
  //getCategorization
  LITE_DOCUMENTS_CATEGORIZATION: 'LITE_DOCUMENTS_CATEGORIZATION',
  //getCategorization
  LITE_DOCUMENTS_CONTRACT: 'LITE_DOCUMENTS_CONTRACT',
  //getGeneralTerms
  LITE_DOCUMENTS_GENERALTERMS: 'LITE_DOCUMENTS_GENERALTERMS',
  //getGeneralTerms
  LITE_DOCUMENTS_PRICELIST: 'LITE_DOCUMENTS_PRICELIST',
  //getLanguages
  LITE_LANGUAGES: 'LITE_LANGUAGES',
  //getAppSettings
  LITE_APP_SETTINGS: 'LITE_APP_SETTINGS',
  //getIntegrationPartners
  LITE_INTEGRATION_PARTNERS: 'LITE_INTEGRATION_PARTNERS',
  //getIntegrationPartnerDetails
  LITE_INTEGRATION_PARTNER_DETAILS: 'LITE_INTEGRATION_PARTNER_DETAILS',

  //getDiscountPackages
  LITE_RENTALS_DISCOUNT_PACKAGES: 'LITE_RENTALS_DISCOUNT_PACKAGES',

  //getPropertyUnitsDiscounts
  LITE_RENTALS_PROPERTY_UNIT_DISCOUNTS: 'LITE_RENTALS_PROPERTY_UNIT_DISCOUNTS',

  //getDiscountFeeTypes
  LITE_RENTALS_DISCOUNT_FEE_TYPES: ' LITE_RENTALS_DISCOUNT_FEE_TYPES',

  //getDiscountApplyPriceTypes
  LITE_RENTALS_DISCOUNT_APPLY_PRICE_TYPES: ' LITE_RENTALS_DISCOUNT_APPLY_PRICE_TYPES',

  //getPromotionDiscount
  LITE_RENTALS_PROMOTION_DISCOUNT: ' LITE_RENTALS_PROMOTION_DISCOUNT',

  //getFirstMinuteDiscount
  LITE_RENTALS_FIRST_MINUTE_DISCOUNT: ' LITE_RENTALS_FIRST_MINUTE_DISCOUNT',

  //getLastMinuteDiscount
  LITE_RENTALS_LAST_MINUTE_DISCOUNT: ' LITE_RENTALS_LAST_MINUTE_DISCOUNT',

  //getLongerStayDiscount
  LITE_RENTALS_LONGER_STAY_DISCOUNT: ' LITE_RENTALS_LONGER_STAY_DISCOUNT',

  //getFlexibleRuleDiscount
  LITE_RENTALS_FLEXIBLE_RULE_DISCOUNT: ' LITE_RENTALS_FLEXIBLE_RULE_DISCOUNT',

  //getPropertyContracts
  LITE_RENTALS_PROPERTY_CONTRACTS: ' LITE_RENTALS_PROPERTY_CONTRACTS',

  //getContractsByCode
  LITE_RENTALS_CONTRACTS_BY_CODE: ' LITE_RENTALS_CONTRACTS_BY_CODE',

  //getCooperationTypes
  LITE_COOPERATION_TYPES: ' LITE_COOPERATION_TYPES',

  //getEvisitor
  LITE_EVISITOR: 'LITE_EVISITOR',

  //printContract
  LITE_PRINT_CONTRACT: ' LITE_PRINT_CONTRACT',

  //getContractDocuments
  LITE_CONTRACT_DOCUMENTS: ' LITE_CONTRACT_DOCUMENTS',

  LITE_ICAL_PROPERTIES: 'LITE_ICAL_PROPERTIES',

  LITE_UNITS_OCCUPANCIES: 'LITE_UNITS_OCCUPANCIES',

  LITE_UNITS_RESERVATIONS: 'LITE_UNITS_RESERVATIONS',

  LITE_ANALYTICS_QUALITY_ANALYTICS: 'LITE_ANALYTICS_QUALITY_ANALYTICS',

  LITE_ANALYTICS_OCCUPANCY_ANALYTICS: 'LITE_ANALYTICS_OCCUPANCY_ANALYTICS',

  LITE_ANALYTICS_RESERVATION_DURATION_ANALYTICS: 'LITE_ANALYTICS_RESERVATION_DURATION_ANALYTICS',

  LITE_ANALYTICS_AVERAGE_PRICE_ANALYTICS: 'LITE_ANALYTICS_AVERAGE_PRICE_ANALYTICS',

  LITE_ANALYTICS_EARNINGS_ANALYTICS: 'LITE_ANALYTICS_EARNINGS_ANALYTICS',

  LITE_ANALYTICS_UNITS: 'LITE_ANALYTICS_UNITS',
};

export default LITE;
